import api from '../../api'

const getDefaultState = () => {
  return {
    all: [],
    fromStation: [],
    toStation: []
  }
}

const state = getDefaultState()

const getters = {
  getStations: (state) =>  {
    return state.all
  },
  getFromStation: (state) =>  {
    return state.fromStation[0]
  },
  getToStation: (state) =>  {
    return state.toStation[0]
  }
}

const actions = {
  search ({ rootGetters, commit }, name) {
    api.searchStation(name, rootGetters['user/getLang'])
      .then((stations) => {
        commit('setStations', stations)
      })
  },
  searchFromStation ({ rootGetters, commit, state }, name) {
    return new Promise((resolve) => {
      if (state.fromStation.length === 0 || state.fromStation[0].Station.name !== name) {
        api.getStation(name, rootGetters['user/getLang'])
          .then((station) => {
            commit('setFromStation', station)
            resolve()
          })
      } else {
        resolve()
      }
    })
  },
  searchToStation ({ rootGetters, commit, state }, name) {
    return new Promise((resolve) => {
      if (state.toStation.length === 0 || state.toStation[0].Station.name !== name) {
        api.getStation(name, rootGetters['user/getLang'])
          .then((station) => {
            commit('setToStation', station)
            resolve()
          })
      } else {
        resolve()
      }
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setStations (state, stations) {
    state.all = stations
  },
  setFromStation (state, station) {
    state.fromStation = station
  },
  setToStation (state, station) {
    state.toStation = station
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
